import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import TextIcon from 'components/TextIcon/component';

export default styled(TextIcon)`
  font-size: 12px;
  width: ${gridSizes('M')};
  height: ${gridSizes('M')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid;
  border-color: var(--grey900);
  font-weight: 500;
  color: var(--grey900);
  opacity: 0.7;

  &.white {
    color: var(--white);
    border: 1px solid var(--white);
  }

  &.blue {
    color: var(--primary500);
    border-color: var(--primary500);
  }

  &.warning {
    color: var(--accent700);
    border-color: var(--accent700);
  }

  &.color-inherit {
    border-color: inherit;
    color: inherit;
  }

  @media print {
    display: none !important;
  }
`;
